define('SageDotCom/Components/Collections/LightboxCarousel',[
    'jquery',
    'SageDotCom/DataLayer/tealium',
    'SageDotCom/DataLayer/Events/bodySelect',
    'SageDotCom/DataLayer/Events/carouselGeneric'
],
    function ($, tealium, bodySelectEvent, carouselEvent) {
        function LightboxCarousel(scope) {
            
            // Gallery image hover
            $(".img-wrapper", scope).hover(
                function () {
                    $(this).find(".img-overlay").animate({ opacity: 1 }, 600);
                },
                function () {
                    $(this).find(".img-overlay").animate({ opacity: 0 }, 600);
                }
            );

            // Lightbox
            var $overlay = $('<div class="overlay" tabindex="0"></div>', scope);
            var $image = $("<img>", scope);
            var $prevButton = $('<div class="prevButton" tabindex="0"></div>', scope);
            var $nextButton = $('<div class="nextButton" tabindex="0"></div>', scope);
            var $exitButton = $('<div class="exitButton" tabindex="0"></div>', scope);

            // image devices for the user to click to show as the main image
            var $desktopBtn = $(".desktop-button", scope);
            var $tabletBtn = $(".tablet-button", scope);
            var $mobileBtn = $(".mobile-button", scope);

            // Add overlay
            $overlay.append($image).prepend($prevButton).append($nextButton).append($exitButton);
            $(".gallery", scope).append($overlay);

            // Hide overlay on default
            $overlay.hide();

            // When an image is clicked
            $(".img-wrapper", scope).on("keypress click", function (event) {

                // This will only work with a click or if the Enter key is pressed
                if (event.keyCode === 13 || event.type === 'click') {
                    // Prevents default behavior
                    event.preventDefault();
                    // Adds href attribute to variable
                    var imageLocation = $(this).find(".img-overlay").prev().children()[0].src;
                    // Add the image src to $image
                    $image.attr("src", imageLocation);
                    // Fade in the overlay
                    $overlay.fadeIn("slow");

                    // Don't show the next and previous button if only one image exists
                    var $images = $(".image-gallery", scope).find(".image");

                    if ($images.length <= 1) {
                        $prevButton.removeAttr("tabindex");
                        $prevButton.hide();
                        $nextButton.removeAttr("tabindex");
                        $nextButton.hide();
                    }

                    var eventSchema = bodySelectEvent.GenerateEventMetadata(scope, 'expand');
                    tealium.event(eventSchema);
                }
            });

            // When next button is clicked
            $nextButton.on("keypress click", function (event) {

                // This will only work with a click or if the Enter key is pressed
                if (event.keyCode === 13 || event.type === 'click') {
                    // Hide the current image
                    $(".overlay img", scope).hide();
                    // Overlay image location
                    var $currentImgSrc = $(".overlay img", scope).attr("src");

                    // Finds the next image
                    var $nextImg = getImageToShow($currentImgSrc, false);
                    // All of the images in the gallery
                    var $images = $(".image-gallery", scope).find(".image");

                    // If there is a next image
                    if ($nextImg.length > 0) {
                        // Fade in the next image
                        $(".overlay img", scope).attr("src", $nextImg.attr("src")).fadeIn(800);
                    } else {
                        // Otherwise fade in the first image
                        $(".overlay img", scope).attr("src", $($images[0]).attr("src")).fadeIn(800);
                    }
                    // Prevents overlay from being hidden
                    event.stopPropagation();

                    var eventSchema = carouselEvent.GenerateEventMetadata(scope, 'right', 'lightbox');
                    tealium.event(eventSchema);
                }
            });

            // When previous button is clicked
            $prevButton.on("keypress click", function (event) {

                // This will only work with a click or if the Enter key is pressed
                if (event.keyCode === 13 || event.type === 'click') {
                    // Hide the current image
                    $(".overlay img", scope).hide();
                    // Overlay image location
                    var $currentImgSrc = $(".overlay img", scope).attr("src");

                    // Finds the next image
                    var $prevImg = getImageToShow($currentImgSrc, true);

                    // All of the images in the gallery
                    var $images = $(".image-gallery", scope).find(".image");

                    // If there is a next image
                    if ($prevImg.length > 0) {
                        // Fade in the next image
                        $(".overlay img", scope).attr("src", $prevImg.attr("src")).fadeIn(800);
                    } else {
                        // Otherwise fade in the first image
                        $(".overlay img", scope).attr("src", $($images[$images.length - 1]).attr("src")).fadeIn(800);
                    }

                    // Prevents overlay from being hidden
                    event.stopPropagation();

                    var eventSchema = carouselEvent.GenerateEventMetadata(scope, 'left', 'lightbox');
                    tealium.event(eventSchema);
                }
            });

            // When the exit button is clicked, have to use keydown instead of keypress for the escape key to work
            $exitButton.on("keydown click", function (event) {

                // This will only work with a click or if the Escape key is pressed
                if (event.keyCode === 27 || event.type === 'click') {
                    // Fade out the overlay
                    $(".overlay", scope).fadeOut("slow");

                    var eventSchema = bodySelectEvent.GenerateEventMetadata(scope, 'collapse');
                    tealium.event(eventSchema);
                }
            });

            // This will determine what image to show next or prev based on the current image shown
            function getImageToShow(currentImgSrc, isPrev) {

                var imageGallery = $(".image-gallery", scope).find(".image").find('a').find('img');
                var index = 0;
                var imagesLen = imageGallery.length;
                var imageIndex = 0;
                var imageToUse;

                // Get the index in the imageGallery array that is currently used
                for (var x = 0; x < imagesLen; x++) {
                    if (imageGallery[x].getAttribute('src') === currentImgSrc || imageGallery[x].src === currentImgSrc) {
                        index = x;
                    }
                }

                if (isPrev) {
                    imageIndex = index === 0 ? imagesLen - 1 : (index - 1);
                } else {
                    imageIndex = index === imagesLen - 1 ? 0 : (index + 1);
                }

                // getAttribute('src') is needed if you want to grab the port in the src as well
                imageToUse = $('.image-gallery .image a img[src="' + imageGallery[imageIndex].getAttribute('src') + '"]', scope);

                return imageToUse;
            }

            // This will show and hide the images based on the class name given
            function showHideImages(className) {
                var clsName = $.trim(className);
                var el;
                var $galleryImages = $(".image-gallery", scope).find(".image");
                for (var i = 0; i < $galleryImages.length; i++) {
                    el = $($galleryImages[i]);

                    // hide if the classname if not given and it is the first element
                    if (clsName === '') {

                        // make the device image active on the first load
                        if (i === 0) {
                            var imgType = el.attr('data-type');

                            if (imgType) {
                                if (imgType === "desktop")
                                    $desktopBtn.addClass('active');

                                if (imgType === "mobile")
                                    $mobileBtn.addClass('active');

                                if (imgType === "tablet")
                                    $tabletBtn.addClass('active');
                            }
                        }

                        // hide all the images but the first one
                        if (i > 0)
                          el.hide();
                    }

                    // show the classname given and hide all others
                    if (clsName !== '') {
                        if (el[0].className.indexOf(clsName) !== -1) {
                            el.show();

                        } else {
                            el.hide();
                        }
                    }
                }
            }

            // Don't show the device thumbnail images if the pane was not added to the carousel
            function showHideThumbnailImages($elem) {
                var $grandParentElem = $elem.parent().parent();
                var $images = $(".image-gallery", scope).find(".image");
                if ($images.length <= 1 || $grandParentElem.find("." + $elem.attr('data-img')).length === 0) {
                    $elem.hide();
                }
            }

            // Only show the first image and hide the rest
            showHideImages('');

            // Hide the device buttons if the images don't exist
            showHideThumbnailImages($desktopBtn);
            showHideThumbnailImages($tabletBtn);
            showHideThumbnailImages($mobileBtn);

            $desktopBtn.click(function (event) {
                event.preventDefault();
                showHideImages($(this).attr('data-img'));
                $(this).addClass('active');
                $tabletBtn.removeClass('active');
                $mobileBtn.removeClass('active');

                var eventSchema = bodySelectEvent.GenerateEventMetadata(scope, 'desktop');
                tealium.event(eventSchema);
            });

            $tabletBtn.click(function (event) {
                event.preventDefault();
                showHideImages($(this).attr('data-img'));
                $(this).addClass('active');
                $desktopBtn.removeClass('active');
                $mobileBtn.removeClass('active');

                var eventSchema = bodySelectEvent.GenerateEventMetadata(scope, 'tablet');
                tealium.event(eventSchema);
            });

            $mobileBtn.click(function (event) {
                event.preventDefault();
                showHideImages($(this).attr('data-img'));
                $(this).addClass('active');
                $desktopBtn.removeClass('active');
                $tabletBtn.removeClass('active');

                var eventSchema = bodySelectEvent.GenerateEventMetadata(scope, 'mobile');
                tealium.event(eventSchema);
            });
        }

        return function init(args) {
            return args.IsExperienceEditorEditing ? null : new LightboxCarousel(args.scope);
        };
    });
